import { render, staticRenderFns } from "./RichInput.vue?vue&type=template&id=21fa9ca8&scoped=true&"
import script from "./RichInput.vue?vue&type=script&lang=js&"
export * from "./RichInput.vue?vue&type=script&lang=js&"
import style0 from "./RichInput.vue?vue&type=style&index=0&id=21fa9ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fa9ca8",
  null
  
)

export default component.exports